<template>
  <div class="hot-brand-list">
     <div class="item" :class="{ active: !brand.pcauto_id }" @click="selectItem({})">全部</div>
    <div
      @click="selectItem(item)"
      v-for="(item, index) in hotBrandList"
      :key="index"
      :class="{ active: brand.pcauto_id === item.pcauto_id }"
      class="item"
    >
      {{ item.name }}
    </div>
    <div class="item" @click="clickMore" :class="{ active: isMore }">更多品牌</div>
  </div>
</template>
<script>
export default {
  name: 'HotBrand',
  props: {
    brand: {
      type: Object,
      default() {
        return {};
      },
    },
    hotBrandList: {
      type: Array,
      default() {
        return [];
      },
    },
    isMore: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    selectItem(item) {
      this.$emit('selectItem', item);
    },
    clickMore() {
      this.$emit('clickMore');
    },
  },
};
</script>
<style lang="scss" scoped>
.hot-brand-list {
  width: 680px;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  padding-top: 20px;
  .item {
    width: 135px;
    height: 56px;
    line-height: 56px;
    text-align: center;
    box-sizing: border-box;
    border-radius: 8px;
    margin: 0 0 20px 27px;
    color: #ffffff;
    border: 1px solid #fff8a0;
    background: transparent;
    font-size: 28px;
    &.active {
      color: #1b5af1;
      background: linear-gradient(to right, #fffffd, #fff799);
    }
  }
}
.normal-hot {
  .item {
    color: #1483ff;
    background: #ffffff;
    &.active {
      color: #ffffff;
      background: #1483ff;
    }
  }
}
</style>
